//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CollapsedMenuItem from "./CollapsedMenuItem.vue";
import Vue from "vue";

export default {
  name: "CollapsedMenuList",

  componentName: "CollapsedMenuList",

  components: {
    CollapsedMenuItem,
  },

  props: {
    menuData: {
      type: Array,
      required: true,
    },
    isChild: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      displayMenus: [],
      toggleShow: false,
    };
  },

  mounted() {
    let data = this.menuData.concat();
    if (data && data.length) {
      data.forEach((item) => {
        if (item.children) {
          item.isExpand = false;
        }
      });
    }
    this.displayMenus = data;
  },

  methods: {
    handleToggleShow(item, index) {
      this.$nextTick(() => {
        item.isExpand = !item.isExpand;
        Vue.set(this.displayMenus, index, item);
      });
    },
    onClickLink(item) {
      if (item.link) {
        window.location = item.link;
        this.$hideModal("CollapsedMenuList");
      } else if (item.children) {
        this.displayMenus = item.children.concat();
      }
    },
  },
};
